import { helper } from '@ember/component/helper';

export function defaultFormColumns(/*params, hash*/) {
  return 'col-12 col-md-8 col-lg-6';
}

export default helper(defaultFormColumns);
